export const backendURL = process.env.VUE_APP_API_URL;
